import React, { useEffect, useRef } from 'react';
import { IconInfoCircle } from '@tabler/icons-react';
import { Popover } from 'bootstrap/dist/js/bootstrap.js';
import PropTypes from 'prop-types';

const PopoverInfoIcon = ({ popoverInfo, headerContent = null }) => {
  const iconRef = useRef(null);
  const popoverInstance = useRef(null);

  useEffect(() => {
    if (iconRef.current) {
      popoverInstance.current = new Popover(iconRef.current, {
        container: 'div',
        trigger: 'hover',
        html: true,
        placement: 'bottom',
        content: `
          <div>
            <div id=${headerContent ? 'cst-popover-content1' : 'cst-popover-content'}>
                <h3>${headerContent ?? 'Severity Description'}</h3>
                <ul>
                    ${Object.entries(popoverInfo)
                      .map(
                        ([key, value]) =>
                          `<li><span class=${value}></span>${key}</li>`,
                      )
                      .join('')}
                </ul>
            </div>
          </div>
        `,
      });
    }

    // Cleanup on unmount
    return () => {
      if (popoverInstance.current) {
        popoverInstance.current.dispose();
      }
    };
  }, []);

  return (
    <IconInfoCircle
      ref={iconRef}
      size={14}
      className="ti ti-info-circle ms-1"
      role="button"
      tabIndex={0}
    />
  );
};

PopoverInfoIcon.propTypes = {
  popoverInfo: PropTypes.object.isRequired,
  headerContent: PropTypes.string,
};

export default PopoverInfoIcon;
